/* eslint-disable jsx-a11y/iframe-has-title */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Col, Row, Button, Form, Popover } from 'antd';
import {
    CheckCircleFilled,
    FullscreenExitOutlined,
    FullscreenOutlined,
    PauseCircleFilled,
    PlayCircleFilled,
    SoundOutlined,
    SoundFilled,
} from '@ant-design/icons';
import { withApollo } from '@apollo/client/react/hoc';
import {
    ReactMarkdown, InputValuesObject,
    getIntFromString,
    RenderUploadWithCrop,
    withMarkdownFieldValue
} from '../../look';

import { compose } from 'modules/core';
import { FILTER_SURVEY_CHOICE } from '../graphql/filterSurveyChoice.gql'
import SurveyCheckBoxField from 'modules/survey-look/containers/survey-checkbox-filed';
import SurveyColorField from 'modules/survey-look/containers/survey-color-filed';
import SurveyDatePickerField from 'modules/survey-look/containers/survey-datepicker-field';
import SurveyTimePicker from 'modules/survey-look/containers/survey-time-field';
import SurveyRadioField from 'modules/survey-look/containers/survey-radio-button-filed';
import SurveyRangeField from 'modules/survey-look/containers/survey-range-filed';
import SurveyTextField from 'modules/survey-look/containers/survey-text-field';
import SurveySelectField from 'modules/survey-look/containers/survey-select-filed';
import help_icon from '../../assets/help-text.svg'
import CKEditorFieldSurvey from 'modules/survey-look/containers/survey-ck-editio-filed';
import "../css/diversity-new-skin.css"
import FillInTheBlanks from './fillInTheBlanks';
import RenderParaQuestions from './RenderParaQuestions';
export const TIME_LIMIT = 5;

const normalizeMediaType = (mediaType) => (mediaType || '').toString().toUpperCase();

const formatMediaTime = (seconds) => {
    if (isNaN(seconds) || seconds < 0) return "00:00";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const pad = (val) => String(val).padStart(2, "0");
    if (hrs > 0) {
        return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
    }
    return `${pad(mins)}:${pad(secs)}`;
};

const getMediaStorageKey = (surveyId, questionId) => `media_${surveyId || 's'}_${questionId}`;

const readMediaProgress = (surveyId, questionId) => {
    const key = getMediaStorageKey(surveyId, questionId);
    let raw = localStorage.getItem(key);
    if (!raw) {
        raw = localStorage.getItem(questionId);
        if (raw) {
            localStorage.setItem(key, raw);
        }
    }
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
};

const writeMediaProgress = (surveyId, questionId, data) => {
    const key = getMediaStorageKey(surveyId, questionId);
    localStorage.setItem(key, JSON.stringify(data));
};

const emailRules = { type: 'email', message: 'Not a vaild email' };

export function getTypeFromQuestion(question) {
    return question?.choiceSet?.edges[0]?.node?.inputType;
}

const DviversitySurveySelectionnewSkinComponent = (props) => {


    const {
        questionList,
        handleFormTrigger,
        form,
        srNo,
        setShowOkbutton,
        submitted,
        selectedvalues,
        survey,
        client,
        group,
        currentIdx,
        goNext,
        doNothing,
        form_values,
        formValues,
        mediaInfo,
        setMediaInfo,
        dataRef
    } = props;

    const [open, setOpen] = useState(false);
    const values = form.getFieldsValue(true);
    const [showInput, setShowInput] = React.useState(false)

    let available_type_for_okay = [
        InputValuesObject.checkbox,
        InputValuesObject.ckeditor,
        InputValuesObject.email,
        InputValuesObject.number,
        InputValuesObject.password,
        InputValuesObject.telephone,
        InputValuesObject.tel,
        InputValuesObject.text,
        InputValuesObject.textarea,
        InputValuesObject.url,
        InputValuesObject.color,
        InputValuesObject.fillinblank,
        InputValuesObject.noassisttextarea
    ]

    const getRangeValues = (choiceSet, type) => {
        let defaultValue = 0,
            marks = {},
            step = 1;
        const value = choiceSet[0]?.value?.split(':') || [];
        if (type === 'RANGE') {
            marks[value[0]] = value[0];
            marks[value[1]] = value[1];
            step = value[2] === '0' ? '1' : value[2];
            defaultValue = value[3];
        }

        return { step, marks, defaultValue, min: Number(value[0]), max: Number(value[1]) };
    };

    const OperandValues = (id) => {
        if (values) {
            if (values[id] !== undefined) {
                return true
            }
            else {
                return false
            }
        }

    }

    const OperandSelectedValues = (id) => {
        setShowInput(true)
    }
    const helpContent = (text) => {
        return (
            <div style={{ maxWidth: "400px", width: "100%" }}>
                <p className='generic-survey-help-text'><ReactMarkdown>{text}</ReactMarkdown></p>
                <button className='generic-survey-help-text-btn' onClick={() => setOpen(false)}>Got it</button>
            </div>
        )
    }

    const RenderQuestion = (question, index) => {
        const [selectedq_id, setSelectedId] = React.useState()
        const [colorLoading, setColorLoading] = React.useState(false);
        const [load, setLoad] = useState(false);
        const { id, questionText, required, helpText } = question;
        const [choiceSet, setchoiceSet] = React.useState(question?.choiceSet)
        const type = getTypeFromQuestion(question);
        const [selectedCheckboxValueStore, setSelectedCheckboxValueStore] = React.useState({})
        // eslint-disable-next-line no-unused-vars
        const [selected_question_id, setSelectedQuestionId] = React.useState()
        const [hide_okay_btn, SetHideOkayBtn] = React.useState(false)
        const [restrictBlurAfterOk, setRestrictBlurAfterOk] = React.useState(false)
        const [paraAnswers, setParaAnswers] = React.useState([])
        const audioRef = React.useRef()
        const videoRef = React.useRef()
        const playerContainerRef = React.useRef()
        const lastAllowedTimeRef = React.useRef(0)
        const [isFullscreen, setIsFullscreen] = React.useState(false)
        const normalizedMediaType = normalizeMediaType(question?.mediaType)
        const isAudioMedia = normalizedMediaType === 'AUDIO'
        const isVideoMedia = normalizedMediaType === 'VIDEO'
        const isMediaQuestion = isAudioMedia || isVideoMedia
        const surveyIdForMedia = getIntFromString(survey?.id) || 's'


        // --- No-assist textarea state management ---
        const [textareaValue, setTextareaValue] = React.useState(formValues?.[id] || ''); // State for textarea content


        let oke_time_out_ref = React.useRef()
        const handleOkayBtn = (hide_okay) => {
            if (oke_time_out_ref?.current) {
                clearTimeout(oke_time_out_ref?.current)
                oke_time_out_ref.current = undefined
            }
            if (hide_okay_btn === false && hide_okay === false)
                SetHideOkayBtn(0)
            else
                SetHideOkayBtn(hide_okay)
            if (InputValuesObject.ckeditor === type && hide_okay) {
                setRestrictBlurAfterOk(true)
            }
            if (!hide_okay) {
                oke_time_out_ref.current = setTimeout(() => {
                    SetHideOkayBtn(true)
                }, 10000);
            }
        }

        const onSelectFeildSearch = async (search, question) => {
            let id = survey?.id;
            const { data } = await client.query({
                query: FILTER_SURVEY_CHOICE,
                variables: { id: id, label_Icontains: search },
                // fetchPolicy: 'network-only'
            });
            if (data?.Options) {
                let groupData = data?.Options?.groupSet?.edges?.find(item => item?.node?.id === group?.node?.id)
                if (groupData) {
                    let currentQuestion = groupData?.node?.questionSet?.edges?.find(item => item?.node?.id === question?.id)
                    if (currentQuestion) {
                        setchoiceSet(currentQuestion?.node?.choiceSet)
                    }
                }
            }
        }

        React.useEffect(() => {
            if (id) {
                let selectdCheck = JSON.parse(localStorage.getItem('oldValue'))
                let checkPrevious = {}
                if (selectdCheck) {
                    checkPrevious[id] = selectdCheck[id]
                }
                setSelectedCheckboxValueStore(checkPrevious)
            }
        }, [id])
        const obj = {};
        const keyArray = Object.keys(values);
        keyArray?.length > 0 &&
            // eslint-disable-next-line array-callback-return
            keyArray.map(key => {
                obj[getIntFromString(key)] = values[key];
            });
        const label = (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '0px' }}>
                <h4 >{srNo}.</h4>
                <ReactMarkdown style={{ marginLeft: '4px' }}>{questionText}</ReactMarkdown>
            </div>
        );

        const renderLabel = (
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "5px", width: "100%", paddingTop: "10px" }}>
                {required && <span style={{ color: "#DE4A4A" }}>*</span>}
                {label}
            </div>
        );
        const placeholderLabel = (
            <Row>
                <p>Select a</p><ReactMarkdown style={{ marginLeft: '4px' }}>{questionText}</ReactMarkdown>
            </Row>

        )
        const rules = [{ required: true, message: 'An answer is required.' }];

        const { step, marks, defaultValue, min, max } = getRangeValues(
            choiceSet?.edges?.map(({ node }) => node),
            type
        );

        const handleCkEditorData = (id, event) => {
            let data = withMarkdownFieldValue(id, { [id]: event })
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], data[id]))
        }

        const handleFillInTheBlanksData = (id, value) => {
            let data = { [id]: value }
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], data[id]))
        }

        const handleChange = (selectedId, choices, type, doNext, q_id) => {
            if (type === InputValuesObject.select) {
                handleFormTrigger(1)
            }
            if (InputValuesObject.ckeditor !== type) {
                handleOkayBtn(false)
            } else {
                if (restrictBlurAfterOk) {
                    setRestrictBlurAfterOk(false)
                } else {
                    handleOkayBtn(false)
                }
            }
            let selectedAnswer
            if (type === 'CHECKBOX') {
                let selectedCheckboxValue = JSON.parse(localStorage.getItem('oldValue'))
                if (!selectedCheckboxValue) {
                    selectedCheckboxValue = {}
                }
                let oldVal = selectedCheckboxValueStore[id]
                let change = []
                let lenOldVal = oldVal ? oldVal.length : 0

                selectedCheckboxValue[id] = selectedId
                localStorage.setItem('oldValue', JSON.stringify(selectedCheckboxValue))
                if (lenOldVal > selectedId.length) {
                    change = oldVal.filter(item => !selectedId.includes(item))
                }
                else if (lenOldVal < selectedId.length) {
                    change = selectedId.filter(item => {
                        if (oldVal) {
                            return !oldVal.includes(item)
                        }
                        else {
                            return true
                        }
                    })
                }

                setSelectedCheckboxValueStore({ ...selectedCheckboxValueStore, [id]: selectedId })
                selectedAnswer = change[0]
            } else if (type === InputValuesObject.range && choices?.edges?.[0]?.node) {
                choices.edges[0].node.selectedRange = selectedId
                selectedAnswer = selectedId
            } else {
                selectedAnswer = selectedId
            }
            if (doNext) {
                setTimeout(() => {
                    setSelectedQuestionId()
                    if (!selectedq_id) {
                        setShowOkbutton(true, srNo)
                        setSelectedId()
                    }
                    else {
                        doNothing(srNo)
                        setSelectedId()
                    }

                }, 500)
            }
            else {
                setShowOkbutton(false, srNo)
                setSelectedQuestionId(q_id)
            }
            let select = choices?.edges.find(({ node }) => node?.value === selectedAnswer || node?.selectedRange === selectedAnswer)
            selectedvalues(getIntFromString(select?.node?.id), select?.node?.sequence, id, type)
        };

        const onNextStep = (values) => {
            submitted(values)
        }

        const gotToNextAction = (id, sr_no) => {
            if (!selectedq_id) {
                goNext(sr_no)
            }
            else {
                doNothing(srNo)
                setSelectedId()
            }
        }

        useEffect(() => {
            const savedData = readMediaProgress(surveyIdForMedia, id);
            if (savedData?.is_saved && isMediaQuestion && !mediaInfo[id]?.is_saved) {
                handleProceedToAssessment(question)
                handleChange([question?.choiceSet?.edges?.[0]?.node?.value], choiceSet, type, true, id)
                setMediaInfo({
                    ...mediaInfo,
                    [id]: savedData
                })
            }
            const audio = audioRef.current;
            const video = videoRef.current;
            if (!(audio || video)) return;

            const handleLoadedMetadata = (media, q_id) => {
                lastAllowedTimeRef.current = media.currentTime || 0
                dataRef.current = {
                    ...dataRef.current,
                    [q_id]: {
                        ...(dataRef.current?.[q_id] || {}),
                        duration: media.currentTime,
                        max_duration: media.duration,
                        is_playing: false,
                        has_error: false,
                        is_muted: media.muted,
                    }
                }
                if (mediaInfo?.selectedQuestionID === null || JSON.stringify(mediaInfo) === "{}")
                    setMediaInfo(dataRef.current)
            };

            const onAudioLoaded = () => handleLoadedMetadata(audio, id);
            const onVideoLoaded = () => handleLoadedMetadata(video, id);

            if (audio) {
                audio.addEventListener("loadedmetadata", onAudioLoaded);
            }
            if (video) {
                video.addEventListener("loadedmetadata", onVideoLoaded);
            }
            return () => {
                if (video && typeof video.removeEventListener === 'function') {
                    video.removeEventListener("loadedmetadata", onVideoLoaded);
                }
                if (audio && typeof audio.removeEventListener === 'function') {
                    audio.removeEventListener("loadedmetadata", onAudioLoaded);
                }
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        useEffect(() => {
            const onFullscreenChange = () => {
                setIsFullscreen(!!document.fullscreenElement)
            }
            document.addEventListener('fullscreenchange', onFullscreenChange)
            return () => document.removeEventListener('fullscreenchange', onFullscreenChange)
        }, [])

        const updateMediaState = (patch) => {
            const { selectedQuestionID, ...rest } = patch
            setMediaInfo({
                ...mediaInfo,
                ...(selectedQuestionID !== undefined ? { selectedQuestionID } : {}),
                [id]: {
                    ...mediaInfo[id],
                    ...rest,
                }
            })
        }

        const getActiveMediaEl = () => (isVideoMedia ? videoRef.current : audioRef.current)

        const playMedia = (e) => {
            if (e && e.stopPropagation) e.stopPropagation()
            if (mediaInfo[id]?.is_completed || mediaInfo[id]?.has_error) return
            const mediaEl = getActiveMediaEl()
            if (mediaEl) {
                const playPromise = mediaEl.play()
                if (playPromise && playPromise.catch) {
                    playPromise.catch(() => {
                        setMediaInfo((prev) => ({
                            ...prev,
                            [id]: {
                                ...prev[id],
                                has_error: true,
                                is_playing: false,
                            }
                        }))
                    })
                }
            }
            setMediaInfo({
                ...mediaInfo,
                selectedQuestionID: id,
                [id]: {
                    ...mediaInfo[id],
                    is_playing: true,
                    has_error: false,
                }
            })
        }

        const pauseMedia = (e) => {
            if (e && e.stopPropagation) e.stopPropagation()
            const mediaEl = getActiveMediaEl()
            if (mediaEl) mediaEl.pause()
            updateMediaState({ is_playing: false })
        }

        const toggleMute = (e) => {
            if (e && e.stopPropagation) e.stopPropagation()
            const mediaEl = getActiveMediaEl()
            if (!mediaEl) return
            mediaEl.muted = !mediaEl.muted
            updateMediaState({ is_muted: mediaEl.muted })
        }

        const toggleFullscreen = (e) => {
            if (e && e.stopPropagation) e.stopPropagation()
            const container = playerContainerRef.current
            const videoEl = videoRef.current
            if (document.fullscreenElement) {
                if (document.exitFullscreen) document.exitFullscreen()
                return
            }
            if (container && container.requestFullscreen) {
                container.requestFullscreen()
                return
            }
            if (videoEl && videoEl.webkitEnterFullscreen) {
                videoEl.webkitEnterFullscreen()
            }
        }

        const handleMediaTimeUpdate = (mediaEl) => {
            if (!mediaEl) return
            lastAllowedTimeRef.current = mediaEl.currentTime
            setMediaInfo({
                ...mediaInfo,
                [id]: {
                    ...mediaInfo[id],
                    duration: mediaEl.currentTime,
                    max_duration: mediaEl.duration || mediaInfo[id]?.max_duration
                }
            })
        }

        const handleMediaSeeking = (mediaEl) => {
            if (!mediaEl || mediaInfo[id]?.is_completed) return
            const allowed = lastAllowedTimeRef.current || 0
            if (mediaEl.currentTime > allowed + 0.35) {
                mediaEl.currentTime = allowed
            }
        }

        const handleMediaEnded = () => {
            const completedState = {
                ...mediaInfo[id],
                is_playing: false,
                is_completed: true,
                duration: mediaInfo[id]?.max_duration || mediaInfo[id]?.duration
            }
            setMediaInfo({
                ...mediaInfo,
                [id]: completedState
            })
            writeMediaProgress(surveyIdForMedia, id, completedState)
            const existing = localStorage.getItem("saved_question_ids") || ""
            if (!existing.split(',').includes(String(id))) {
                localStorage.setItem("saved_question_ids", existing ? `${existing},${id}` : String(id))
            }
        }

        const handleMediaError = () => {
            updateMediaState({
                has_error: true,
                is_playing: false,
            })
        }

        const handleProceedToAssessment = (question) => {
            form.setFieldsValue(_.set(form.getFieldsValue(true), [id], question?.choiceSet?.edges?.[0]?.node?.value));
        }

        const showQuestion = () => {
            let showMedia = true
            const savedData = readMediaProgress(surveyIdForMedia, id)
            if (savedData) {
                showMedia = !savedData?.is_saved
            }
            return !mediaInfo[id]?.is_saved && showMedia
        }

        useEffect(() => {
            if (mediaInfo?.selectedQuestionID === null || JSON.stringify(mediaInfo) === "{}") {
                setMediaInfo(dataRef.current)
            }
            if (mediaInfo[id]?.is_playing && mediaInfo?.selectedQuestionID !== id) {
                if (videoRef.current || audioRef.current) {
                    if (isVideoMedia && videoRef.current) videoRef.current.pause()
                    if (isAudioMedia && audioRef.current) audioRef.current.pause()
                }
                setMediaInfo({
                    ...mediaInfo,
                    [id]: {
                        ...mediaInfo[id],
                        is_playing: false
                    }
                })
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [mediaInfo])

        const mediaProgressPct = (() => {
            const max = mediaInfo[id]?.max_duration || 0
            const current = mediaInfo[id]?.duration || 0
            if (!max) return 0
            return Math.min(100, Math.max(0, (current / max) * 100))
        })()

        const renderMediaControls = () => {
            const isCompleted = !!mediaInfo[id]?.is_completed
            const isPlaying = !!mediaInfo[id]?.is_playing
            const isMuted = !!mediaInfo[id]?.is_muted
            const hasError = !!mediaInfo[id]?.has_error

            return (
                <div className="survey-media-controls" onClick={(e) => e.stopPropagation()}>
                    <button
                        type="button"
                        className={`survey-media-control-btn ${isCompleted ? 'is-completed' : ''}`}
                        onClick={isPlaying ? pauseMedia : playMedia}
                        disabled={isCompleted || hasError}
                        aria-label={isCompleted ? 'Completed' : (isPlaying ? 'Pause' : 'Play')}
                        title={isCompleted ? 'Completed — replay disabled' : (isPlaying ? 'Pause' : 'Play')}
                    >
                        {isCompleted
                            ? <CheckCircleFilled />
                            : (isPlaying ? <PauseCircleFilled /> : <PlayCircleFilled />)}
                    </button>
                    <span className="survey-media-time">{formatMediaTime(mediaInfo[id]?.duration)}</span>
                    <div
                        className="survey-media-progress"
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={Math.floor(mediaInfo[id]?.max_duration || 0)}
                        aria-valuenow={Math.floor(mediaInfo[id]?.duration || 0)}
                        aria-label="Playback progress (seeking disabled)"
                        title="Seeking is disabled"
                    >
                        <div className="survey-media-progress-fill" style={{ width: `${mediaProgressPct}%` }} />
                    </div>
                    <span className="survey-media-time">{formatMediaTime(mediaInfo[id]?.max_duration)}</span>
                    <button
                        type="button"
                        className="survey-media-control-btn"
                        onClick={toggleMute}
                        aria-label={isMuted ? 'Unmute' : 'Mute'}
                        title={isMuted ? 'Unmute' : 'Mute'}
                    >
                        {isMuted ? <SoundOutlined /> : <SoundFilled />}
                    </button>
                    {isVideoMedia && (
                        <button
                            type="button"
                            className="survey-media-control-btn"
                            onClick={toggleFullscreen}
                            aria-label="Fullscreen"
                            title="Fullscreen"
                        >
                            {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                        </button>
                    )}
                </div>
            )
        }



        return (
            <div key={index}>

                <Form
                    form={form}
                    name={"value"}
                    // layout={'vertical'}
                    required={required}
                    onFinish={(values) => { onNextStep(values) }
                    }
                >
                    {<div style={{ minWidth: '200px' }}>
                        <div className="generic-survey-question-container" style={{ background: OperandValues(id) ? "rgba(236, 241, 244, 1)" : "rgba(244, 249, 253, 1)" }} key={index} visible={srNo - 1 === currentIdx} >
                            {
                                isMediaQuestion
                                    ? showQuestion() ?
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                gap: "10px",
                                            }}
                                            onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}
                                        >
                                            <div
                                                className="question-instruction"
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    cursor: "pointer"
                                                }}>
                                                <h4 className='generic-survey-question' >{renderLabel}</h4>
                                                {
                                                    helpText &&
                                                    <Popover
                                                        visible={open}
                                                        trigger="click"
                                                        overlayClassName="generic-survey-help-text-popover"
                                                        placement="topRight"
                                                        content={helpContent(helpText)}
                                                    >
                                                        <img src={help_icon} alt='' style={{ cursor: "pointer", width: "25px" }} onClick={() => setOpen(true)} />
                                                    </Popover>
                                                }
                                            </div>
                                            <p className="survey-media-hint">
                                                Play the full {isVideoMedia ? 'video' : 'audio'} once to continue. Seeking and replay are disabled.
                                            </p>
                                            <div
                                                className={`survey-media-player ${isVideoMedia ? 'is-video' : 'is-audio'}`}
                                                ref={playerContainerRef}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {isAudioMedia && (
                                                    <>
                                                        <div className="survey-audio-stage">
                                                            <SoundFilled className="survey-audio-stage-icon" />
                                                            <span>{mediaInfo[id]?.is_completed ? 'Audio completed' : 'Audio player'}</span>
                                                        </div>
                                                        <audio
                                                            ref={audioRef}
                                                            preload="metadata"
                                                            onTimeUpdate={() => handleMediaTimeUpdate(audioRef.current)}
                                                            onSeeking={() => handleMediaSeeking(audioRef.current)}
                                                            onEnded={handleMediaEnded}
                                                            onError={handleMediaError}
                                                        >
                                                            <source src={question?.url} type="audio/mpeg" />
                                                            <source src={question?.url} type="audio/ogg" />
                                                            <source src={question?.url} type="audio/wav" />
                                                        </audio>
                                                    </>
                                                )}
                                                {isVideoMedia && (
                                                    <div className="survey-video-stage">
                                                        <video
                                                            ref={videoRef}
                                                            playsInline
                                                            preload="metadata"
                                                            onTimeUpdate={() => handleMediaTimeUpdate(videoRef.current)}
                                                            onSeeking={() => handleMediaSeeking(videoRef.current)}
                                                            onEnded={handleMediaEnded}
                                                            onError={handleMediaError}
                                                        >
                                                            <source src={question?.url} type="video/mp4" />
                                                            <source src={question?.url} type="video/webm" />
                                                            <source src={question?.url} type="video/ogg" />
                                                        </video>
                                                    </div>
                                                )}
                                                {renderMediaControls()}
                                                {mediaInfo[id]?.has_error && (
                                                    <div className="survey-media-error">
                                                        Unable to load this media. Use a direct file URL (e.g. Cloudinary .mp4 / .mp3), not YouTube or other page links.
                                                    </div>
                                                )}
                                            </div>
                                            <div className="proceed-to-assessment">
                                                <Button
                                                    className='generic-survey-proceed-button'
                                                    style={{ height: "2.5em" }}
                                                    disabled={!mediaInfo[id]?.is_completed || mediaInfo[id]?.has_error}
                                                    onClick={e => {
                                                        e.stopPropagation()
                                                        handleProceedToAssessment(question)
                                                        handleChange([question?.choiceSet?.edges?.[0]?.node?.value], choiceSet, type, true, id)
                                                        handleFormTrigger(1)
                                                        const savedState = {
                                                            ...mediaInfo[id],
                                                            is_saved: true,
                                                            q_id: id,
                                                            c_id: question?.choiceSet?.edges?.[0]?.node?.id,
                                                            seq: 1
                                                        }
                                                        writeMediaProgress(surveyIdForMedia, id, savedState)
                                                        setMediaInfo({
                                                            ...mediaInfo,
                                                            [id]: savedState
                                                        })
                                                    }}
                                                >
                                                    Proceed to Assessment
                                                </Button>
                                                {!mediaInfo[id]?.is_completed && (
                                                    <p className="survey-media-proceed-hint">
                                                        Finish {isVideoMedia ? 'watching' : 'listening'} to unlock
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        :
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: "10px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}
                                        >
                                            <h4 className='generic-survey-question' > {srNo}. You have completed the {normalizedMediaType.toLowerCase()}, now you can proceed with assessment</h4>
                                            {
                                                helpText &&
                                                <Popover
                                                    visible={open}
                                                    trigger="click"
                                                    overlayClassName="generic-survey-help-text-popover"
                                                    placement="topRight"
                                                    content={helpContent(helpText)}
                                                >
                                                    <img
                                                        src={help_icon}
                                                        alt=''
                                                        style={{ cursor: "pointer", width: "25px" }}
                                                        onClick={() => setOpen(true)}
                                                    />
                                                </Popover>
                                            }
                                        </div>
                                    :
                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", gap: "10px", cursor: "pointer" }} onClick={() => showInput ? setShowInput(false) : (OperandSelectedValues(id), setSelectedId(id))}>
                                        <h4 className='generic-survey-question' >{renderLabel}</h4>
                                        {
                                            helpText &&
                                            <Popover
                                                visible={open}
                                                trigger="click"
                                                overlayClassName="generic-survey-help-text-popover"
                                                placement="topRight"
                                                content={helpContent(helpText)}
                                            >
                                                <img
                                                    src={help_icon}
                                                    alt=''
                                                    style={{ cursor: "pointer", width: "25px" }}
                                                    onClick={() => setOpen(true)}
                                                />
                                            </Popover>
                                        }
                                    </div>
                            }
                            {(srNo - 1 === currentIdx || values[id] !== undefined || showInput) && !isMediaQuestion && (
                                <div style={{ marginTop: "10px" }}>
                                    {type === InputValuesObject.checkbox && (
                                        <SurveyCheckBoxField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.color && !colorLoading && (
                                        <SurveyColorField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            onChange={e => {
                                                setColorLoading(true);
                                                e && form.setFieldsValue(_.set(form.getFieldsValue(true), [id], e));
                                                setColorLoading(false);
                                                handleChange(e, choiceSet, type, false, id)
                                            }}
                                            value={form.getFieldValue(id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.date && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            format="YYYY-MM-DD"
                                            rules={[{ required, message: 'Please select a date' }]}
                                            enabledisabledDate={false}
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.datetime && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            // label={label}
                                            offset={3}
                                            showTime={{ format: 'HH:mm' }}
                                            format="YYYY-MM-DD HH:mm"
                                            rules={[{ required, message: 'Please select a date and time' }]}
                                            enabledisabledDate={false}
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.month && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            picker="month"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.time && (
                                        <SurveyTimePicker
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            type="time"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.week && (
                                        <SurveyDatePickerField
                                            margin={false}
                                            name={id}
                                            //   label={label}
                                            offset={3}
                                            rules={[{ required, message: 'Please select a month' }]}
                                            enabledisabledDate={false}
                                            picker="week"
                                            onChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        // defaultValue={moment('2015-06-06', 'YYY-MM-DD')}
                                        />
                                    )}
                                    {type === InputValuesObject.radio && (
                                        <SurveyRadioField
                                            name={id}
                                            //   label={renderLabel}
                                            choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                            rules={required ? rules : []}
                                            onChange={e => e?.target?.value && handleChange(e?.target?.value, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.range && (
                                        <SurveyRangeField
                                            name={id}
                                            className={`generic-survey-range-slider ${formValues && Object.keys(formValues)?.find(answeredId => answeredId === getIntFromString(id)) ? '' : 'not-answered-slider'}`}
                                            //   label={
                                            //     <div style={{ minWidth: '25vw', maxWidth: 'calc(100% - 30px)' }}>
                                            //       {label}
                                            //       <ReactMarkdown style={{ marginLeft: '3vw' }}>{helpText}</ReactMarkdown>
                                            //     </div>
                                            //   }
                                            rules={required ? rules : []}
                                            marks={marks}
                                            step={step}
                                            defaultValue={defaultValue}
                                            min={min}
                                            max={max}
                                            trackStyle={{ backgroundColor: '#B0CB1F' }}
                                            handleStyle={{ backgroundColor: '#B0CB1F' }}
                                            onAfterChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.email && (
                                        <SurveyTextField
                                            name={id}
                                            // label={renderLabel}
                                            rules={required ? rules.map(r => ({ ...r, ...emailRules })) : [{ ...emailRules }]}
                                            // rules={[{ type: 'email' }]}
                                            offset={2}
                                            onChange={e => e.target.value && handleChange(e, choiceSet, type, false, id)}
                                            onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.ckeditor && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <CKEditorFieldSurvey
                                                    name={id}
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    initialValue={formValues[id] || ''}
                                                    onChange={e => { handleCkEditorData(id, e); handleChange(false); handleOkayBtn(false) }}
                                                    onBlur={e => { handleCkEditorData(id, e); handleChange(false, undefined, type) }}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.file && (
                                        <RenderUploadWithCrop
                                            setUrl={e => { e && handleChange(true); form.setFieldsValue(_.set(form.getFieldsValue(true), id, e)) }}
                                            setLoad={setLoad}
                                            offset={2}
                                            name={id}
                                            //   label={renderLabel}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.text && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveyTextField
                                                    name={id}
                                                    //   label={renderLabel}
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                                    onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.number && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            type="number"
                                            offset={2}
                                            onChange={e => e && handleChange(e, choiceSet, type, false, id)}
                                            onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                            required={required}
                                        />
                                    )}
                                    {type === InputValuesObject.select && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveySelectField
                                                    showSearch
                                                    onSearch={(e) => { onSelectFeildSearch(e, question) }}
                                                    otherOption={true}
                                                    name={id}
                                                    offset={2}
                                                    placeholder={placeholderLabel}
                                                    rules={required ? rules : []}
                                                    choices={choiceSet.edges.map(({ node }) => node).map(c => ({ label: c.label, value: c.value }))}
                                                    onSelectChange={e => e && handleChange(e, choiceSet, type, true, id)}
                                                    onBlur={e => e?.target?.value && handleChange(e, choiceSet, type, false, id)}
                                                    required={required}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.password && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            type="password"
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.tel && (
                                        <SurveyTextField
                                            name={id}
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            max_length={10}
                                            type="number"
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.url && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <SurveyTextField
                                                    name={id}
                                                    //   label={renderLabel}
                                                    type="url"
                                                    rules={required ? rules : []}
                                                    offset={2}
                                                    onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                                    onBlur={e => e?.target?.value && handleChange(false)}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {type === InputValuesObject.textarea && (
                                        <SurveyTextField
                                            name={id}
                                            type="textarea"
                                            //   label={renderLabel}
                                            rules={required ? rules : []}
                                            offset={2}
                                            onChange={e => { handleChange(false); handleOkayBtn(false) }}
                                            onBlur={e => e?.target?.value && handleChange(false)}
                                        />
                                    )}
                                    {type === InputValuesObject.noassisttextarea && (
                                        choiceSet?.edges?.[0]?.node?.value !== "para_question"
                                            ? (<div
                                                style={{
                                                    width: '100%',
                                                    position: 'relative',
                                                    marginTop: '8px',
                                                    marginBottom: '24px',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}>
                                                <textarea
                                                    rows={6}
                                                    autoComplete="off"
                                                    spellCheck={false}
                                                    data-gramm="false"
                                                    data-gramm_editor="false"
                                                    data-enable-grammarly="false"
                                                    className="fitb-input para-textarea"
                                                    value={textareaValue}
                                                    onChange={(e) => {
                                                        setTextareaValue(e.target.value);
                                                        form.setFieldsValue({ [id]: e.target.value });
                                                        handleChange(false);
                                                        handleOkayBtn(false);
                                                    }}
                                                    onBlur={(e) => {
                                                        setTextareaValue(e.target.value.trim());
                                                        form.setFieldsValue({ [id]: e.target.value.trim() });
                                                        handleChange(false);
                                                    }}
                                                    onCopy={(e) => e.preventDefault()}
                                                    onPaste={(e) => e.preventDefault()}
                                                    onCut={(e) => e.preventDefault()}
                                                    onContextMenu={(e) => e.preventDefault()}
                                                    onKeyDown={(e) => {
                                                        // Block Tab key to prevent autocorrect issues
                                                        if (e.key === 'Tab') {
                                                            e.preventDefault();
                                                            return false;
                                                        }
                                                        
                                                        // Block Ctrl+C, Ctrl+V, Ctrl+X, Ctrl+A (and Cmd on Mac)
                                                        if ((e.ctrlKey || e.metaKey) && (
                                                            e.key === 'c' || e.key === 'C' ||
                                                            e.key === 'v' || e.key === 'V' ||
                                                            e.key === 'x' || e.key === 'X' ||
                                                            e.key === 'a' || e.key === 'A'
                                                        )) {
                                                            e.preventDefault();
                                                            return false;
                                                        }
                                                    }}
                                                    style={{
                                                        width: '100%',
                                                        minHeight: '150px',
                                                        padding: '8px 12px',
                                                        border: '1px solid #d9d9d9',
                                                        borderRadius: '4px',
                                                        background: 'white !important',
                                                        fontFamily: 'inherit',
                                                        fontSize: '14px',
                                                        lineHeight: '1.5',
                                                        textAlign: 'left',
                                                        verticalAlign: 'top',
                                                        resize: 'vertical',
                                                        textDecoration: 'none !important',
                                                        borderBottom: '1px solid #d9d9d9 !important'
                                                    }}
                                                />
                                            </div>)
                                            : choiceSet?.edges?.[0]?.node?.label?.split(".")
                                                ?.map(ele => ele.trim())
                                                ?.map((sentence, index) => (
                                                    sentence && <RenderParaQuestions
                                                        id={id}
                                                        key={index}
                                                        type={type}
                                                        form={form}
                                                        index={index}
                                                        sentence={sentence}
                                                        choiceSet={choiceSet}
                                                        formValues={formValues}
                                                        paraAnswers={paraAnswers}
                                                        handleChange={handleChange}
                                                        setParaAnswers={setParaAnswers}
                                                        InputValuesObject={InputValuesObject}
                                                    />
                                                ))
                                    )}
                                    {type === InputValuesObject.fillinblank && (
                                        <Row>
                                            <Col lg={24} xs={20}>
                                                <FillInTheBlanks
                                                    id="fill-in-the-blanks"
                                                    className="fill-in-the-blanks"
                                                    InputValue={
                                                        choiceSet?.edges?.[0]?.node?.value
                                                    }
                                                    initialValue={
                                                        formValues?.[id]
                                                    }
                                                    onChange={(text) => {
                                                        handleFillInTheBlanksData(id, text);
                                                        handleOkayBtn(false);
                                                        handleChange(false)
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {(available_type_for_okay?.includes(type) && form_values[id] && !hide_okay_btn) && (
                                        <>
                                            <Button className='generic-survey-ok-button' style={{ height: "2.5em" }} disabled={load} onClick={e => { gotToNextAction(id, srNo - 1); setSelectedQuestionId(); handleOkayBtn(true) }}>
                                                Okay
                                            </Button>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>}
                </Form>
            </div>
        )
    };

    return (
        <>
            {questionList?.map(RenderQuestion)}
        </>
    )
}

export default compose(withApollo)(DviversitySurveySelectionnewSkinComponent)

